module.exports = __webpack_public_path__ + "static/media/Polygon.bf28a289.svg";